let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8JZKd"), load("a5PnA"), load("1XElS")]).then(() => parcelRequire('60ePl'));